import { IController } from 'angular';
import * as _ from 'lodash';
import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { GraduationPlanWarnings as Warnings } from '../../../../../../../ng2/shared/constants/graduation-plan-warnings.constant';
import { GraduationPlanWarningsCreditAndRegentsThresholds as WarningThresholds } from '../../../../../../../ng2/shared/constants/graduation-plan-warnings.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class PotentialConflictsCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public activeStudentsByCohort;
  public currentCohortFilter;
  public currentCohortFilterIncludingSuperSeniors;
  public currentCohortContainsSuperSeniors;
  public warningBuckets;
  public withWarning: string[];
  public incomplete: string[];
  public lessThan90Attendance: string[];
  public lessThanCreditsRegentsCheck: string[];
  public greaterOrEqualTo2Gaps: string[];
  public localEligiblePlannedForRegents: string[];
  public creditThresholdForWarning: string[];
  public regentsThresholdForWarning: string;
  public filterOptions;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filterOptions = { columnKeys: ['gradPlan', 'gradPlanWarnings'] };

    this.currentCohortFilterIncludingSuperSeniors = this.WizardUtils.getCurrentCohortFilter();
    this.currentCohortFilter = _.last(this.currentCohortFilterIncludingSuperSeniors);
    const currentCohortDetails = Cohort[this.currentCohortFilter];
    const currentStudentYear = currentCohortDetails.studentYear;
    this.currentCohortContainsSuperSeniors = currentStudentYear === 4;

    this.activeStudentsByCohort = this.WizardUtils.getFilteredFlattenedStudents({
      status: ['A', 'A-NDG'],
      cohort: this.currentCohortFilterIncludingSuperSeniors,
    });

    this.warningBuckets = this.generateFilteredStudentIdBuckets();
    this.withWarning = this.warningBuckets.withWarning;
    this.incomplete = this.warningBuckets.incomplete;
    this.lessThan90Attendance = this.warningBuckets.lessThan90Attendance;
    this.lessThanCreditsRegentsCheck = this.warningBuckets.lessThanCreditsRegentsCheck;
    this.greaterOrEqualTo2Gaps = this.warningBuckets.greaterOrEqualTo2Gaps;
    this.localEligiblePlannedForRegents = this.warningBuckets.localEligiblePlannedForRegents;
    this.creditThresholdForWarning = WarningThresholds[currentStudentYear].lessThanCredits;
    this.regentsThresholdForWarning = WarningThresholds[currentStudentYear].lessThanRegents;
  }

  private generateFilteredStudentIdBuckets(): object {
    const buckets = {
      withWarning: [],
      incomplete: [],
      lessThan90Attendance: [],
      lessThanCreditsRegentsCheck: [],
      greaterOrEqualTo2Gaps: [],
      localEligiblePlannedForRegents: [],
    };
    _.each(this.activeStudentsByCohort, (student: any) => {
      const { studentId, gradPlanWarnings } = student;
      if (!gradPlanWarnings) return;
      if (gradPlanWarnings.length >= 1) buckets.withWarning.push(studentId);
      _.each(gradPlanWarnings, warning => {
        if (warning === Warnings.incompleteGradPlan) buckets.incomplete.push(studentId);
        if (warning === Warnings.lessThan90AttendanceLastYear) buckets.lessThan90Attendance.push(studentId);
        if (warning === Warnings.lessThanCreditsRegentsCheck) buckets.lessThanCreditsRegentsCheck.push(studentId);
        if (warning === Warnings.greaterOrEqualTo2CreditGaps) buckets.greaterOrEqualTo2Gaps.push(studentId);
        if (warning === Warnings.localEligiblePlannedForRegents) buckets.localEligiblePlannedForRegents.push(studentId);
      });
    });
    return buckets;
  }
}
